<template>
  <div class="tw-flex">
    <div
      v-for="step in steps"
      :key="step"
      class="tw-relative"
      :style="step !== steps ? `width: calc(${100 / (steps - 1)}% - 2px)` : ''"
    >
      <span
        v-if="step !== steps"
        class="tw-block tw-h-1"
        :class="activeStep > step ? 'tw-bg-secondary dark:tw-bg-dm-secondary' : 'tw-bg-gray dark:tw-bg-dm-gray'"
      />
      <div
        class="tw-absolute tw-transform tw--left-px tw-text-xs tw-text-white dark:tw-text-dm tw-rounded-full tw-flex tw-items-center tw-justify-center tw-font-medium"
        :class="[
          activeStep === step ? 'tw-w-4 tw-h-4 tw--top-1.5' : 'tw-h-2 tw-w-2 tw--top-0.5',
          activeStep >= step ? 'tw-bg-secondary dark:tw-bg-dm-secondary' : 'tw-bg-gray dark:tw-bg-dm-gray',
        ]"
      >
        {{ activeStep === step ? step : '' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Number,
      default: 0,
    },
    activeStep: {
      type: Number,
      default: 0,
    },
  },
};
</script>
